import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';
import * as nggt from 'angular-gettext';
import * as moment from 'moment';

import { SiteConfig, Loader } from '../shared';
import { TimeoutService } from '../timeout';

class ShellController implements ng.IComponentController {
   static $inject = ['$window', '$location', '$stateParams', 'gettextCatalog', 'config', 'loader', 'timeoutService'];

   constructor(
      private $window:ng.IWindowService,
      private $location:ng.ILocationService,
      $stateParams:uir.StateParams,
      private gettextCatalog:nggt.gettextCatalog,
      private config:SiteConfig,
      public loader:Loader,
      private timeoutService:TimeoutService
   ) {
      this.language = $stateParams.lang;
   }

   $onInit() {
      this.timeoutService.startSession();
   }

   uiOnParamsChanged(newValues:any, $transition$:uir.Transition) {
      this.timeoutService.checkSession();
      if (newValues.lang) {
         this.language = newValues.lang;
         // reload when language changes so server renders index with new lang
         this.$window.location.href = this.$location.absUrl();
      }
   }

   get settings() {
      return this.config.settings;
   }

   set language(language: string) {
      this.$window.document.documentElement.lang = language;
      this.gettextCatalog.setCurrentLanguage(language);
      moment.locale(language);
   }
}

ng.module('selfReg').component('shell', {
   templateUrl: require('./shell.html'),
   controller: ShellController
});
